// extracted by mini-css-extract-plugin
export default {"title":"LocationsSection_title__BQYmu","search":"LocationsSection_search__flXlz","tableResponsiveWrapper":"LocationsSection_tableResponsiveWrapper__p1LwS"};